import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: "",
  error: "",
  reset: false,
};

const recaptchaSlice = createSlice({
  name: "recaptcha",
  initialState,
  reducers: {
    updateToken(state, action) {
      state.token = action.payload;
    },
    updateError(state, action) {
      state.error = action.payload;
      state.token = "";
    },
    updateReset(state, action) {
      state.reset = action.payload;

      if (action.payload) {
        state.token = "";
      }
    },
  },
});

export const recaptchaActions = recaptchaSlice.actions;

export default recaptchaSlice.reducer;
